/* ============================================
   Azuri TPO — Label mover + Dynamic description
   ============================================ */

(function() {
  var EASIFY_SEL = 'input.tpo_image-swatches-input[name*="Select gemstone quality" i]';
  var HIDDEN_SEL = 'input[name*="Select Gemstone Quality"], input[name*="Select gemstone quality"]';

  var descriptions = {
    'D': '(D) Colorless grade - The pinnacle of pure, colorless brilliance exceptional flawlessly white diamonds.',
    'E-F': '(E-F) Exceptional whiteness with near colorless brilliance.',
    'G-H': '(G-H) Near colorless grade - Excellent value with minimal color visible to the naked eye'
  };

  var infoBar = null;
  var setupDone = false;
  var userClicked = false;
  var updateTimer = null;

  function setup() {
    if (document.querySelector('#azuri-info-bar')) return true;

    var container = document.querySelector('.tpo_option-set-container');
    if (!container) return false;

    var radios = container.querySelectorAll(EASIFY_SEL);
    if (radios.length === 0) return false;

    /* --- Label mover --- */
    document.querySelectorAll('.tpo_image-swatches-wrapper').forEach(function(w) {
      var label = w.querySelector('.tpo_option_label');
      var desc = w.querySelector('.tpo_option_type_description.below_swatch');
      if (label && desc && desc.nextElementSibling !== label) {
        desc.parentNode.insertBefore(label, desc.nextSibling);
      }
    });

    /* --- Hide static description paragraph --- */
    container.querySelectorAll('.tpo_option-container').forEach(function(oc) {
      var text = oc.textContent || '';
      if (text.indexOf('(D)') > -1 && text.indexOf('(E-F)') > -1) {
        oc.style.display = 'none';
      }
    });

    /* --- Create single dynamic info bar --- */
    var gemInput = container.querySelector(HIDDEN_SEL);
    if (gemInput) {
      var gemContainer = gemInput.closest('.tpo_option-container');
      if (gemContainer) {
        infoBar = document.createElement('div');
        infoBar.id = 'azuri-info-bar';
        infoBar.style.cssText = 'display:none;padding:10px;background:#ffffff;border-radius:8px;text-align:left;font-size:13px;color:#6b6b6b;font-family:Arsenal;margin-top:-4px;margin-bottom:12px;width:100%;box-sizing:border-box;';
        gemContainer.parentNode.insertBefore(infoBar, gemContainer.nextSibling);
      }
    }

    return true;
  }

  function normalizeGrade(val) {
    if (!val) return null;
    var str = String(val).trim();
    var upper = str.toUpperCase();
    if (upper === 'D' || /^D\b/.test(upper)) return 'D';
    if (/^E\s*[-–/]?\s*F\b/.test(upper) || upper === 'E-F' || upper === 'EF' || upper === 'E' || upper === 'F') return 'E-F';
    if (/^G\s*[-–/]?\s*H\b/.test(upper) || upper === 'G-H' || upper === 'GH' || upper === 'G' || upper === 'H') return 'G-H';
    return null;
  }

  function getSelected() {
    var nativePicker = document.querySelector('fieldset.quality-picker input[type="radio"]:checked') ||
                       document.querySelector('.quality-picker input[type="radio"]:checked') ||
                       document.querySelector('variant-picker input[name*="option3"]:checked') ||
                       document.querySelector('variant-picker input[name*="quality" i]:checked');
    if (nativePicker && nativePicker.value && normalizeGrade(nativePicker.value)) {
      return nativePicker;
    }

    var hidden = document.querySelector(HIDDEN_SEL);
    if (hidden && hidden.value && normalizeGrade(hidden.value)) return hidden;

    var gemContainers = document.querySelectorAll('.tpo_option-container');
    for (var i = 0; i < gemContainers.length; i++) {
      var container = gemContainers[i];
      if (/gemstone|quality|grade/i.test(container.textContent || '')) {
        var label = container.querySelector('.tpo_is_checked_swatches') ||
                    container.querySelector('.tpo_shape_radius.tpo_is_checked_swatches');
        if (label) {
          var r = label.querySelector('input') || label.querySelector(EASIFY_SEL);
          if (r && r.value && normalizeGrade(r.value)) return r;
          var val = label.getAttribute('data-value') || label.textContent;
          if (val && normalizeGrade(val.trim())) return { value: val.trim() };
        }
      }
    }
    return null;
  }

  function updateDescription() {
    if (!infoBar || !userClicked) return;
    var selected = getSelected();
    var norm = selected && selected.value ? normalizeGrade(selected.value) : null;
    if (norm && descriptions[norm]) {
      infoBar.textContent = descriptions[norm];
      infoBar.style.display = '';
    } else {
      infoBar.textContent = '';
      infoBar.style.display = 'none';
    }
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(updateDescription, 300);
  }

  /* Detect real user clicks only */
  document.addEventListener('click', function(e) {
    if (!setupDone || !e.isTrusted) return;
    if (e.target.closest && (
      e.target.closest('label.tpo_shape_radius') ||
      e.target.closest('.tpo_swatches-label_position') ||
      e.target.closest('.tpo_image-swatches-wrapper') ||
      e.target.closest('.tpo_option_type_label_wrapper') ||
      e.target.closest('.tpo_option_label') ||
      e.target.classList.contains('tpo_image-swatch-img')
    )) {
      userClicked = true;
      scheduleUpdate();
    }
  });

  /* Setup when Easify is ready */
  var attempts = 0;
  var timer = setInterval(function() {
    attempts++;
    if (!setupDone) setupDone = setup();
    if (setupDone || attempts > 80) clearInterval(timer);
  }, 200);

})();